import { gql } from 'urql';

const GET_REMINDER_ACTIONS = gql`
  query GetReminderActions($due_date: date, $current_date: date) {
    companies(where: { expired: { _eq: false } }) {
      id
      name
      enabled_email_notifs
      teams(where: { deleted: { _eq: false } }) {
        id
        name
        team_members {
          company_user {
            user_id
            email_notifs
          }
        }
        actions(
          where: {
            date: { _gte: $current_date, _lte: $due_date }
            completed: { _eq: false }
            archived: { _eq: false }
            assignee: { _is_null: false }
          }
        ) {
          id
          title
          date
          user {
            id
            name
            email
          }
        }
        objectives(
          where: {
            due: { _gte: $current_date, _lte: $due_date }
            _or: [{ status: { _eq: "on-track" } }, { status: { _eq: "off-track" } }, { status: { _is_null: true } }]
            archived: { _eq: false }
            owner: { _is_null: false }
          }
        ) {
          id
          title
          due
          user {
            id
            name
            email
          }
        }
      }
    }
  }
`;

export default GET_REMINDER_ACTIONS;
